import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import MessageBox from 'Components/Utility/MessageBox';

const errors = defineMessages({
  PE000: { id: 'PE000', defaultMessage: 'There was an unexpected problem with your payment, please try again or contact support' },
  PE001: { id: 'PE001', defaultMessage: 'We could not find your order. Please try again' },
  PE002: { id: 'PE002', defaultMessage: 'There was a problem with your payment details. Please try again' },
  PE003: { id: 'PE003', defaultMessage: 'Your logged in user account changed during payment. Please try again' },
  PE004: { id: 'PE004', defaultMessage: 'Your ip address changed during payment. Please try again' },
  PE005: { id: 'PE005', defaultMessage: 'Payment cannot be completed, please try again or contact our support department' },
  PE006: { id: 'PE006', defaultMessage: 'Payment cannot be completed, please try again or contact our support department' }, // Could not handle action from adyen
  PE007: { id: 'PE007', defaultMessage: 'Payment method could not be set to primary' },
  PE008: { id: 'PE008', defaultMessage: 'Payment process timed out, please resubmit your order' },
  PC001: { id: 'PC001', defaultMessage: 'Cardholder name must be entered' },
  PP000: { id: 'PP000', defaultMessage: 'There was an unexpected problem with your Paypal payment, please try again or contact support' },
  PP001: { id: 'PP001', defaultMessage: 'There was an unexpected problem with your Paypal payment, please try again' },
  PP002: { id: 'PP002', defaultMessage: 'You have cancelled your Paypal payment, please try again or choose a different method' },
  PES000: { id: 'PES000', defaultMessage: 'There was an unexpected problem with your voucher, please contact support' },
  PES001: { id: 'PES001', defaultMessage: 'Order not found' },
  PES002: { id: 'PES002', defaultMessage: 'Order already processed' },
  PES003: { id: 'PES003', defaultMessage: 'Order not valid' },
  PSC000: { id: 'PSC000', defaultMessage: 'Failed to remove saved card, please contact support' },
  PSC001: { id: 'PSC001', defaultMessage: 'Failed to remove saved card, user reference not found. Please try again' },
  PSC002: { id: 'PSC002', defaultMessage: 'Failed to remove saved card, card reference not found. Please try again' },
  PSC003: { id: 'PSC003', defaultMessage: 'An error occurred when trying to remove saved card. Please try again or contact support' },
  PPS002: { id: 'PPS002', defaultMessage: 'There was a problem with your payment details. Please try again' },
  PGD000: { id: 'PGD000', defaultMessage: 'There was an unexpected problem with your payment, please try again or contact support' },
  PGD001: { id: 'PGD001', defaultMessage: 'We could not find your order. Please try again' },
  PGD002: { id: 'PGD002', defaultMessage: 'We could not find your order. Please try again' },
  PGD003: { id: 'PGD003', defaultMessage: 'Payment cannot be completed, please try again or contact our support department' },
  PGD004: { id: 'PGD004', defaultMessage: 'Your payment provider refused this order. This can happen for a number of reasons including incorrect card details. Please try again or contact support' },
  PGP000: { id: 'PGP000', defaultMessage: 'There was an unexpected problem with your payment, please try again or contact support' },
  PGP001: { id: 'PGP001', defaultMessage: 'Google Pay refused this order. This can happen for a number of reasons including incorrect card details. Please try again or contact support' },
  PGP002: { id: 'PGP002', defaultMessage: 'There was an unexpected problem with Google Pay, please try again or contact support' },
  PGP003: { id: 'PGP003', defaultMessage: 'Google Pay could not be loaded. Please try a different payment method' },
  PPP000: { id: 'PPP000', defaultMessage: 'There was an unexpected problem with your paypal payment, please try again or choose another payment method' },
  PAP000: { id: 'PAP000', defaultMessage: 'There was an unexpected problem with your payment, please try again or contact support' },
  PAP001: { id: 'PAP001', defaultMessage: 'ApplePay refused this order. This can happen for a number of reasons including incorrect card details. Please try again or contact support' },
  PAP002: { id: 'PAP002', defaultMessage: 'There was an unexpected problem with ApplePay, please try again or contact support' },
  PAP003: { id: 'PAP003', defaultMessage: 'ApplePay could not be loaded. Please try a different payment method' },
  PB001: { id: 'PB001', defaultMessage: 'Some required billing details are missing' },
  PB002: { id: 'PB002', defaultMessage: 'Error saving billing details, please try again' },
  PB003: { id: 'PB003', defaultMessage: 'Invalid billing fields' },
  SPD001: { id: 'SPD001', defaultMessage: 'Error loading payment methods, please try again' },
});

const PaymentError = ({ error, intl }) => {
  if (!error) {
    return false;
  }

  const { formatMessage } = intl;

  let message = formatMessage(errors.PE000);

  if (errors[error]) {
    message = formatMessage(errors[error]);
  }

  return (
    <MessageBox
      paymentSupport={error}
      message={message}
      type="error"
    />
  );
};

export default injectIntl(PaymentError);

PaymentError.propTypes = {
  error: PropTypes.string,
};

PaymentError.defaultProps = {
  error: null,
};
